import { InView } from 'react-intersection-observer';
import style from '../bookis.module.scss'
import animations from '@styles/animations.module.scss'

interface ProjectInfoSectionProps {
    title: string;
    points: Array<Object>;
}
const ProjectInfoSection = ({ title, points }: ProjectInfoSectionProps) => {
    return (
        <section className={`${style.section} ${style.section_gray}`}>
            <div className={`${style.container}`}>
                <div className={`${style.container__flex}`}>
                    <InView triggerOnce={true}>
                        {({ inView, ref, entry }: any) => {
                            if (inView) {
                                entry?.target.classList.add(animations.active);
                            }
                            return (
                                <div ref={ref} className={`${style.bookis__title} ${style.container__title} ${animations.scroll__animation}`}>
                                    {title}
                                </div>
                            )
                        }}
                    </InView>
                    <div className={`${style.container__list} ${style.bookis__list}`}>
                        {points.map((item: any, index: number) => {
                            return (
                                <div className={style.container__list__info} key={index}>
                                    <InView triggerOnce={true}>
                                        {({ inView, ref, entry }: any) => {
                                            if (inView) {
                                                entry?.target.classList.add(animations.active);
                                            }
                                            return (
                                                <div ref={ref} className={`${style.container__title_small} ${animations.scroll__animation}`}>
                                                    {item.title}
                                                </div>
                                            )
                                        }}
                                    </InView>
                                    <InView triggerOnce={true}>
                                        {({ inView, ref, entry }: any) => {
                                            if (inView) {
                                                entry?.target.classList.add(animations.active);
                                            }
                                            return (
                                                <div ref={ref} className={`${style.container__subtitle} ${style.container__subtitle_left} ${animations.scroll__animation}`}>
                                                    {item.subtitle}
                                                </div>
                                            )
                                        }}
                                    </InView>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ProjectInfoSection;
